// RemoveSubcategory.tsx - Modern confirmation modal for removing subcategories
import React, { useState } from 'react';
import { Modal, Button} from 'react-bootstrap';
import { X } from 'react-bootstrap-icons';
import { toast } from 'react-toastify';
import {
  deleteSubCategoryFromCategory,
} from '../../../../../../../../../../crud/menu_api/categories';
import MiniLoadingSpinner from '../../../../../../../../../../components/Spinners/MiniLoadingSpinner';
import './RemoveSubcategory.scss';


const RemoveSubcategory: React.FC<any> = ({
  show,
  handleClose,
  subcategory,
  onSubcategoryRemoved, // optional callback
}) => {
    const [loading, setLoading] = useState(false);


  const handleRemoveSubCategory = async () => {
    setLoading(true);
    deleteSubCategoryFromCategory(Number(subcategory?.id)).then((response) => {;
      toast.success('Subcategoría removida exitosamente');
      if (onSubcategoryRemoved) onSubcategoryRemoved(subcategory);
      handleClose();
      setTimeout(() => {
        window.location.reload();
      }, 200);
    }).catch((error) => {
      console.error('Error eliminando la subcategoría:', error);
      toast.error('Error al eliminar la subcategoría');
    }).finally(() => {
      setLoading(false);
    });
  };

  return (
    <Modal show={show} onHide={handleClose} centered className="remove-subcategory-modal">
      <Modal.Header>
        <div className="form-modal-title-container">
          <Modal.Title className="form-modal-title">Quitar Subcategoría</Modal.Title>
        </div>
        <Button variant="none" className="modal-close-button" onClick={handleClose}>
          <X size={24} />
        </Button>
      </Modal.Header>

      {loading && (
        <div className="loading-overlay">
          <MiniLoadingSpinner />
        </div>
      )}

      {!loading && (
        <Modal.Body>
          <p>
            ¿Estás seguro que deseas remover la subcategoría <strong>{subcategory?.name}</strong>?
          </p>
          
          <div className="explanation-text">
            <p className="explanation-title">
              ¿Qué significa quitar una subcategoría?
            </p>
            <p>
              • La subcategoría se <strong>desvinculará</strong> de su categoría padre<br/>
              • La subcategoría <strong>no se eliminará permanentemente</strong> del sistema<br/>
              • Podrás <strong>volver a vincularla</strong> a cualquier categoría en el futuro<br/>
              • Sus elementos y configuración se mantendrán intactos
            </p>
          </div>
        </Modal.Body>
      )}

      <Modal.Footer>
        <Button variant="none" onClick={handleClose} className="form-button-cancel">
          Cancelar
        </Button>
        <Button 
          variant="none" 
          onClick={handleRemoveSubCategory} 
          className="form-button-remove"
          disabled={loading}
        >
          {loading ? (
            <>
              <span
                className="spinner-border spinner-border-sm"
                role="status"
                aria-hidden="true"
              />{' '}
              Quitando...
            </>
          ) : (
            'Quitar'
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default RemoveSubcategory;
